import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import { useState, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import {
  newAdminPassword,
  newOrganizerPassword,
  newParticipantPassword,
} from '../api/Communication';
import { Link } from 'react-router-dom';

function ResetPassword() {
  const [newPassword, setNewPassword] = useState('');
  const [repeatedPassword, setRepeatedPassword] = useState('');
  const [passwordCompareError, setPasswordCompareError] = useState(false);
  const [invalidPasswordError, setInvalidPasswordError] = useState(false);
  const [changePasswordSuccess, setChangePasswordSuccess] = useState(false);
  const [changePasswordServerError, setChangePasswordServerError] =
    useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const { role: role } = useParams();

  const token = searchParams.get('token');

  useEffect(() => {
    comparePasswords();
  }, [repeatedPassword, newPassword]);

  useEffect(() => {
    checkIfValidPassword();
  }, [newPassword]);

  const onNewPasswordChange = (value) => {
    setNewPassword(value);
  };

  const onRepeatPasswordChange = (value) => {
    setRepeatedPassword(value);
    comparePasswords();
  };

  const checkIfValidPassword = () => {
    const errors = [];

    if (newPassword.length < 8) {
      errors.push('Lösenordet måste vara minst 8 tecken långt');
    }
    if (newPassword.search(/[a-z]/) < 0) {
      errors.push('Lösenordet måste innehålla en eller flera gemener');
    }
    if (newPassword.search(/[A-Z]/) < 0) {
      errors.push('Lösenordet måste innehålla en eller flera gemener');
    }
    if (newPassword.search(/[0-9]/) < 0) {
      errors.push('Lösenordet måste innehålla minst en siffra');
    }

    const regExp = /[""!@$%^&*(){}\[\]:;<>,.?/+_=|'~\\-]/;

    if (!regExp.test(newPassword)) {
      errors.push('Lösenordet måste innehålla minst ett specialtecken');
    }

    if (errors.length > 0) {
      setInvalidPasswordError(true);
      return false;
    }

    setInvalidPasswordError(false);
    return true;
  };

  const comparePasswords = () => {
    if (repeatedPassword.length === 0) {
      return;
    }

    let passwordError = false;
    if (newPassword !== repeatedPassword) {
      passwordError = true;
    }

    setPasswordCompareError(passwordError);
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    if (!passwordCompareError && !invalidPasswordError) {
      const data = {
        token: decodeURIComponent(token),
        newPassword: newPassword,
      };

      if (role === 'admin') {
        const status = await newAdminPassword(data);
        if (status === 200) {
          setChangePasswordServerError(false);
          setChangePasswordSuccess(true);
        } else if (status === 500) {
          setChangePasswordServerError(true);
        }
      } else if (role === 'organizer') {
        const status = await newOrganizerPassword(data);
        if (status === 200) {
          setChangePasswordServerError(false);
          setChangePasswordSuccess(true);
        } else if (status === 500) {
          setChangePasswordServerError(true);
        }
      } else if (role === 'participant') {
        const status = await newParticipantPassword(data);
        if (status === 200) {
          setChangePasswordServerError(false);
          setChangePasswordSuccess(true);
        } else if (status === 500) {
          setChangePasswordServerError(true);
        }
      }
    }
  };

  return (
    <div className='d-flex justify-content-center align-items-center w-100 h-100'>
      <div className='d-flex flex-column bg-white rounded p-4 border box justify-content-between'>
        {changePasswordSuccess ? (
          <div className='d-flex flex-column'>
            <h4 className='d-flex justify-content-center'>
              Lösenord återställt
            </h4>
            <span className='text-center'>
              Du kan nu logga in med ditt nya lösenord.
            </span>
            <div className='d-flex justify-content-center mt-4'>
              {role === 'admin' ? (
                <>
                  <Link to='/admin' className='text-reset text-decoration-none'>
                    <span style={{ color: '#3670b3' }}>
                      Tillbaka till inloggningssidan
                    </span>
                  </Link>
                </>
              ) : role === 'organizer' ? (
                <>
                  <Link
                    to='/organizer'
                    className='text-reset text-decoration-none'
                  >
                    <span style={{ color: '#3670b3' }}>
                      Tillbaka till inloggningssidan
                    </span>
                  </Link>
                </>
              ) : (
                <></>
              )}
            </div>
          </div>
        ) : (
          <Form onSubmit={onSubmit}>
            <h4>Återställ lösenord</h4>
            <p className='mt-1'>
              Välj ett nytt lösenord. Minst 8 tecken samt måste innehålla
              gemener, versaler, sifrror och specialtecken.
            </p>
            <Form.Group controlId='formPassword'>
              <Form.Control
                className='p-2'
                type='password'
                placeholder='Ange nytt lösenord'
                onChange={(e) => onNewPasswordChange(e.target.value)}
              ></Form.Control>
            </Form.Group>

            {invalidPasswordError && newPassword.length > 0 && (
              <span className='text-danger'>Lösenordet är inte giltigt</span>
            )}

            <Form.Group className='mt-2' controlId='formRepeatPassword'>
              <Form.Control
                className='p-2'
                type='password'
                placeholder='Ange nytt lösenord igen'
                onChange={(e) => onRepeatPasswordChange(e.target.value)}
              ></Form.Control>
            </Form.Group>

            {passwordCompareError && (
              <span className='text-danger'>
                Lösenorden överensstämmer inte
              </span>
            )}

            {changePasswordServerError && (
              <Alert key='danger' variant='danger' className='mt-2 p-2 d-flex'>
                <span className='material-symbols-outlined me-2'>error</span>
                Ett oväntat fel inträffade. Vänligen försök igen.
              </Alert>
            )}

            <Button
              className='mt-4 w-100'
              variant='primary'
              type='submit'
              disabled={passwordCompareError || invalidPasswordError}
            >
              Spara nytt lösenord
            </Button>
          </Form>
        )}
      </div>
    </div>
  );
}

export default ResetPassword;
